import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AnimationsModule } from '@ibe.animations/animations.module';
import { CountdownModule } from 'ngx-countdown';
import { RetrievePnrLocatorComponent } from '@ibe.components/booking/search/retrieve-pnr-locator/retrieve-pnr-locator.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { FlightDetailsModule } from '@ibe.components/shared/flight-details/flight-details.module';
import { PaymentModule } from '@ibe.components/shared/payment/payment.module';
import { INDRANavigateAwayModalComponent } from '@ibe.components/shared/navigate-away-modal/navigate-away-modal.indra.component';
import { MyDatePickerModule } from 'mydatepicker';
import { LottieAnimationViewModule } from 'ng-lottie';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { AncillaryBlockGenericComponent } from './ancillary-block-generic/ancillary-block-generic.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { BlockCultureRecomendationComponent } from './block-culture-recomendation/block-culture-recomendation.component';
import { BlockFlightsToCityComponent } from './block-flights-to-city/block-flights-to-city.component';
import { ExtrasIconRowComponent } from './card-extras/extras-icon-row/extras-icon-row.component';
import { TAPExtrasIconRowComponent } from './card-extras/extras-icon-row/extras-icon-row.tap.component';
import { ContactComponent } from './contact/contact.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { FeaturesListComponent } from './flight-brand-features-list/features-list.component';
import { HeroImageComponent } from './hero-image/hero-image.component';
import { TAPHeroImageComponent } from './hero-image/hero-image.tap.component';
import { LoadingCircleComponent } from './loading-circle/loading-circle.component';
import { LoadingShadowComponent } from './loading-shadow/loading-shadow.component';
import { LoadingComponent } from './loading/loading.component';
import { LoadingPaybyrdComponent } from './loading/loadingPaybyrd.component';
import { LoadingModule } from './loading/loading.module';
import { MonthSelectorBarComponent } from './month-selector-bar/month-selector-bar.component';
import { PassengerDropdownComponent } from './passenger-dropdown/passenger-dropdown.component';
import { PassengerComponent } from './passenger/passenger.component';
import { DiscardModalComponent } from './passengers-discard-modal/discard-modal.component';
import { SelectFrequentFlyerProgramsComponent } from './select-frequent-flyer-programs/select-frequent-flyer-programs.component';
import { SkipNavigationComponent } from './skip-navigation/skip-navigation.component';
import { SocialShareComponent } from './social-share/social-share.component';
import { WorldMapSvgComponent } from './world-map-svg/world-map-svg.component';
import { INDRAFlightExploreDestinationsComponent } from '@ibe.components/booking/flights/flight-explore-destinations/flight-explore-destinations.indra.component';
import { RecoverTpNumberComponent } from './recover-tp-number/recover-tp-number.component';
import { BackgroundWorldAnimationComponent } from './background-world-animation/background-world-animation.component';
import { BackgroundIconsAnimationComponent } from './background-icons-animation/background-icons-animation.component';
import { MilesBalanceAnimationComponent } from './miles-balance-animation/miles-balance-animation.component';
import { SuccessTicketAnimationComponent } from './success-ticket-animation/success-ticket-animation.component';
import { DatesPricesNotesComponent } from './dates-prices-notes/dates-prices-notes.component';
import { CorpBalanceComponent } from './sidebar-views/corp-balance/corp-balance.component';
import { BookingModalComponent } from '@ibe.components/shared/booking-modal/booking-modal.component';
import { NewContactModalComponent } from './new-contact-modal/new-contact-modal.component';
import { INDRAHandBaggageInfoBannerComponent } from './hand-baggage-info-banner/hand-baggage-info-banner.indra.component';
// import { AncillaryBlockRentACarComponent } from './ancillary-block-rent-a-car/ancillary-block-rent-a-car.component';
// import { SimpleGalleryComponent } from './simple-gallery/simple-gallery.component';
// import { ExtrasSidebarMilesInfoComponent } from './extras-sidebar-miles-info/extras-sidebar-miles-info.component';
// import { TotalAmountSummaryComponent } from './total-amount-summary/total-amount-summary.component';
// import { InsurancesComponent } from './insurances/insurances.component';
// import { TAPRetrievePnrLocatorComponent } from '@ibe.components/booking/search/retrieve-pnr-locator/retrieve-pnr-locator.tap.component';
// import { AncillaryDiscardModalComponent } from '@ibe.components/shared/ancillary-discard-modal/ancillary-discard-modal.component';
// import { TAPFlightRouteComponent } from '@ibe.components/shared/flight-route/flight-route.tap.component';
// import { SessionTimeoutModalComponent } from '@ibe.components/shared/session-timeout-modal/session-timeout-modal.component';
// import { AddExtraModalComponent } from './add-extra-modal/add-extra-modal.component';
// import { AncillaryBlockOfferComponent } from './ancillary-block-offer/ancillary-block-offer.component';
// import { TAPAutocompleteComponent } from './autocomplete/autocomplete.tap.component';
// import { BlockOfferByCityComponent } from './block-offer-by-city/block-offer-by-city.component';
// import { BlockTapExperienceComponent } from './block-tap-experience/block-tap-experience.component';
// import { ExtrasBlockComponent } from './card-extras/extras-block/extras-block.component';
// import { ChangeFlightModalComponent } from './change-flight-modal/change-flight-modal.component';
// import { CompareBrandsComponent } from './compare-brands/compare-brands.component';
// import { CompareFareModalComponent } from './compare-fare-modal/compare-fare-modal.component';
// import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
// import { TAPContextMenuComponent } from './context-menu/context-menu.tap.component';
// import { DatepickerModalComponent } from './datepicker-modal/datepicker-modal.component';
// import { DaySwitcherComponent } from './day-switcher/day-switcher.tap.component';
// import { TAPFeaturesListComponent } from './flight-brand-features-list/features-list.tap.component';
// import { FlightEditOptionsComponent } from './flight-edit-options/flight-edit-options.component';
// import { IncludedPerPassengerComponent } from './included-per-passenger/included-per-passenger.component';
// import { LoginModalComponent } from './login-modal/login-modal.component';
// import { LoginComponent } from './login/login.component';
// import { TAPMonthSelectorBarComponent } from './month-selector-bar/month-selector-bar.tap.component';
// import { TAPPassengerDropdownComponent } from './passenger-dropdown/passenger-dropdown.tap.component';
// import { PaymentOfferBlockComponent } from './payment-offer-block/payment-offer-block.component';
// import { SelectAirportModalComponent } from './select-airport-modal/select-airport-modal.component';
// import { SelectPassengersModalComponent } from './select-passengers-modal/select-passengers-modal.component';
// import { SelectRegionModalComponent } from './select-region-modal/select-region-modal.component';
// import { SelectThemeModalComponent } from './select-theme-modal/select-theme-modal.component';
// import { SidebarHeaderComponent } from './sidebar-header/sidebar-header.component';
// import { StopoverConfirmModalComponent } from './stopover-confirm-modal/stopover-confirm-modal.component';
// import { StopoverModalComponent } from './stopover-modal/stopover-modal.component';
// import { TicketStopoverComponent } from './ticket-stopover/ticket-stopover.component';
// import { TimelineComponent } from './timeline/timeline.component';
// import { UserTotalMilesInfoComponent } from './user-total-miles-info/user-total-miles-info.tap.component';
// import { SelectMonthModalComponent } from './select-month-modal/select-month-modal.component';
// import { CardOfferHighlightComponent } from './card-offer-highlight/card-offer-highlight.component';
// import { FlightExploreDestinationsComponent } from '@ibe.components/booking/flights/flight-explore-destinations/flight-explore-destinations.component';
// import { SignupErrorModalComponent } from './sidebar-views/signup-error-modal/signup-error-modal.component';
// import { SignupErrorEmailModalComponent } from './sidebar-views/signup-error-email-modal/signup-error-email.modal.tap.component';
// import { CardExtrasFullWidthComponent } from './card-extras-full-width/card-extras-full-width.component';
// import { BusTripModalComponent } from './bus-trip-modal/bus-trip-modal.component';
// import { WeekFlightsDiscountModalComponent } from './week-flights-discount-modal/week-flights-discount-modal.component';
// import { AlternativeFlightsButtonsComponent } from './alternative-flights-buttons/alternative-flights-buttons.component';
// import { ExpirateAlertComponent } from './expirate-alert/expirate-alert.component';
// import { TAPPassengerComponent } from './passenger/passenger.tap.component';
// import { TAPContactComponent } from './contact/contact.tap.component';
// import { TotalSummaryComponent } from './total-summary/total-summary.component';

import { UpliftInformationBlockComponent } from './uplift-information-block/uplift-information-block.component';
import { UpliftBannerComponent } from './uplift-banner/uplift-banner.component';
import { AccesrailBannerComponent } from './accesrail-banner/accesrail-banner.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


/* REPLICATED FILES */
import { INDRARetrievePnrLocatorComponent } from '@ibe.components/booking/search/retrieve-pnr-locator/retrieve-pnr-locator.indra.component';
import { INDRALoginModalComponent } from './login-modal/login-modal.indra.component';
import { INDRALoginComponent } from './login/login.indra.component';
import { INDRASelectAirportModalComponent } from './select-airport-modal/select-airport-modal.indra.component';
import { INDRASelectRegionModalComponent } from './select-region-modal/select-region-modal.indra.component';
import { INDRASelectThemeModalComponent } from './select-theme-modal/select-theme-modal.indra.component';
import { INDRAAutocompleteComponent } from './autocomplete/autocomplete.indra.component';
import { INDRAPassengerDropdownComponent } from './passenger-dropdown/passenger-dropdown.indra.component';
import { INDRAUserTotalMilesInfoComponent } from './user-total-miles-info/user-total-miles-info.indra.component';
import { INDRADatepickerModalComponent } from './datepicker-modal/datepicker-modal.indra.component';
import { INDRAExpirateAlertComponent } from './expirate-alert/expirate-alert.indra.component';
import { INDRADaySwitcherComponent } from './day-switcher/day-switcher.indra.component';
import { INDRASignupErrorEmailModalComponent } from './sidebar-views/signup-error-email-modal/signup-error-email.modal.indra.component';
import { INDRACardExtrasFullWidthComponent } from './card-extras-full-width/card-extras-full-width.indra.component';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';
import { INDRAStopoverModalComponent } from './stopover-modal/stopover-modal.indra.component';
import { INDRASelectMonthModalComponent } from './select-month-modal/select-month-modal.indra.component';
import { INDRAContextMenuComponent } from './context-menu/context-menu.indra.component';
import { INDRAMonthSelectorBarComponent } from './month-selector-bar/month-selector-bar.indra.component';
import { INDRAStopoverConfirmModalComponent } from './stopover-confirm-modal/stopover-confirm-modal.indra.component';
import { INDRAFlightRouteComponent } from '@ibe.components/shared/flight-route/flight-route.indra.component';
import { INDRAIncludedPerPassengerComponent } from './included-per-passenger/included-per-passenger.indra.component';
import { INDRACompareBrandsComponent } from './compare-brands/compare-brands.indra.component';
import { INDRACompareFareModalComponent } from './compare-fare-modal/compare-fare-modal.indra.component';
import { INDRAPaymentOfferBlockComponent } from './payment-offer-block/payment-offer-block.indra.component';
import { INDRABlockOfferByCityComponent } from './block-offer-by-city/block-offer-by-city.indra.component';
import { INDRABusTripModalComponent } from './bus-trip-modal/bus-trip-modal.indra.component';
import { INDRAAncillaryDiscardModalComponent } from '@ibe.components/shared/ancillary-discard-modal/ancillary-discard-modal.indra.component';
import { INDRASessionTimeoutModalComponent } from '@ibe.components/shared/session-timeout-modal/session-timeout-modal.indra.component';
import { INDRAAddExtraModalComponent } from './add-extra-modal/add-extra-modal.indra.component';
import { INDRAChangeFlightModalComponent } from './change-flight-modal/change-flight-modal.indra.component';
import { INDRAConfirmModalComponent } from './confirm-modal/confirm-modal.indra.component';
import { INDRASignupErrorModalComponent } from './sidebar-views/signup-error-modal/signup-error-modal.indra.component';
import { INDRAFlightEditOptionsComponent } from './flight-edit-options/flight-edit-options.indra.component';
import { INDRACardOfferHighlightComponent } from './card-offer-highlight/card-offer-highlight.indra.component';
import { INDRAAlternativeFlightsButtonsComponent } from './alternative-flights-buttons/alternative-flights-buttons.indra.component';
import { INDRASelectPassengersModalComponent } from './select-passengers-modal/select-passengers-modal.indra.component';
import { INDRABlockTapExperienceComponent } from './block-tap-experience/block-tap-experience.indra.component';
import { INDRAFeaturesListComponent } from './flight-brand-features-list/features-list.indra.component';
import { INDRASidebarHeaderComponent } from './sidebar-header/sidebar-header.indra.component';
import { INDRATimelineComponent } from './timeline/timeline.indra.component';
import { INDRATicketStopoverComponent } from './ticket-stopover/ticket-stopover.indra.component';
import { INDRAExtrasBlockComponent } from './card-extras/extras-block/extras-block.indra.component';
import { INDRAAncillaryBlockOfferComponent } from './ancillary-block-offer/ancillary-block-offer.indra.component';
import { INDRAPassengerComponent } from './passenger/passenger.indra.component';
import { INDRAContactComponent } from './contact/contact.indra.component';
import { INDRATotalSummaryComponent } from './total-summary/total-summary.indra.component';
import { INDRAExtrasSidebarMilesInfoComponent } from './extras-sidebar-miles-info/extras-sidebar-miles-info.indra.component';
import { INDRAAncillaryBlockRentACarComponent } from './ancillary-block-rent-a-car/ancillary-block-rent-a-car.indra.component';
import { INDRAWeakFlightsDiscountModalComponent } from './week-flights-discount-modal/weak-flights-discount-modal.indra.component';
import { INDRAAncillaryBlockCartrawlerCrossSellComponent } from './ancillary-block-cartrawler-cross-sell/ancillary-block-cartrawler-cross-sell.component';
import { INDRAStopoverBannerComponent } from './stopover-banner/stopover-banner.indra.component';
import { INDRAStopoverHotelsBannerComponent } from './stopover-hotels-banner/stopover-hotels-banner.indra.component';

// from phase 1 codes:
import { DateFormIndraModule } from './date-form-indra/date-form-indra.module';
import { DateIndraPipe } from './_pipes/date-indra.pipe';
import { CountryDescPipe } from './sidebar-views/passengers-details/_pipes/country-desc.pipe';
import { FrequentFlyerPipe } from './sidebar-views/passengers-details/_pipes/frequent-flyer.pipe';
import { ContactTypeDescPipe } from './sidebar-views/passengers-details/_pipes/contact-type-desc.pipe';
import { DocumentTypeDescPipe } from './sidebar-views/passengers-details/_pipes/document-type-desc.pipe';
import { INDRASimpleGalleryComponent } from './simple-gallery/simple-gallery.indra.component';
import { INDRAPaymentAlertComponent } from './payment-alert/payment-alert.indra.component';
import { INDRACybersourceModalComponent } from './cybersource-modal/cybersource-modal.indra.component';
import { INDRAInsurancesComponent } from './insurances/insurances.indra.component';
import { INDRATotalAmountSummaryComponent } from './total-amount-summary/total-amount-summary.indra.component';
import { INDRAPaymentPaybyrdModalComponent } from './payment-paybyrd-modal/payment-paybyrd-modal.component';
import { INDRANPSBannerComponent } from './nps-banner/nps-banner.indra.component';
import { NPSBannerComponent } from './nps-banner/nps-banner.component';
import { INDRASpecialAssistBannerComponent } from './wheelchair-banner/wheelchair-banner.indra.component';
import { INDRAPaymentAdyenModalComponent } from './payment-adyen-modal/payment-adyen-modal.component';
import { INDRAStepsFooterComponent } from './steps-footer/steps-footer.indra.component';
import { INDRATopMenuBarComponent } from './sidebar-views/top-menu-bar/top-menu-bar.indra.component';
import { INDRABundleCardComponent } from '@ibe.components/booking/extras/bundle-card/bundle-card.indra.component';
import { INDRAPackModalComponent } from './bundles-modal/pack-modal.indra.component';
import { INDRANlfLoginDropdownComponent } from './nlf-login-dropdown/nlf-login-dropdown.indra.component';
import { INDRAEnrollmentBlockComponent } from './enrollment-block/enrollment-block.indra.component';
import { EnrollmentBlockComponent } from './enrollment-block/enrollment-block.component';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		FlightDetailsModule,
		DirectivesModule,
		ReactiveFormsModule,
		FormsModule,
		RouterModule,
		PaymentModule,
		IBEAdminModule,
		PipesModule,
		LoadingModule,
		AnimationsModule,
		MyDatePickerModule,
		LottieAnimationViewModule.forRoot(),
		DateFormIndraModule,
		CountdownModule,
		BsDatepickerModule.forRoot()
	],
	declarations: [
		ContextMenuComponent,
		// TAPContextMenuComponent,
		INDRAContextMenuComponent,
		ExtrasIconRowComponent,
		TAPExtrasIconRowComponent,
		PassengerComponent,
		// TAPPassengerComponent,
		INDRAPassengerComponent,
		ContactComponent,
		// TAPContactComponent,
		INDRAContactComponent,
		HeroImageComponent,
		TAPHeroImageComponent,
		FeaturesListComponent,
		// TAPFeaturesListComponent,
		INDRAFeaturesListComponent,
		// FlightEditOptionsComponent,
		INDRAFlightEditOptionsComponent,
		// AncillaryBlockOfferComponent,
		INDRAAncillaryBlockOfferComponent,
		AncillaryBlockGenericComponent,
		// TAPFlightRouteComponent,
		INDRAFlightRouteComponent,
		SocialShareComponent,
		BackToTopComponent,
		DatesPricesNotesComponent,
		// TimelineComponent,
		INDRATimelineComponent,
		// TicketStopoverComponent,
		INDRATicketStopoverComponent,
		// LoginModalComponent,
		INDRALoginModalComponent,
		SkipNavigationComponent,
		// SidebarHeaderComponent,
		INDRASidebarHeaderComponent,
		SelectFrequentFlyerProgramsComponent,
		// DaySwitcherComponent,
		INDRADaySwitcherComponent,
		// AncillaryDiscardModalComponent,
		INDRAAncillaryDiscardModalComponent,
		// SessionTimeoutModalComponent,
		INDRASessionTimeoutModalComponent,
		// NavigateAwayModalComponent,
		INDRANavigateAwayModalComponent,
		MonthSelectorBarComponent,
		// TAPMonthSelectorBarComponent,
		INDRAMonthSelectorBarComponent,
		// TotalSummaryComponent,
		INDRATotalSummaryComponent,
		// ExpirateAlertComponent,
		INDRAExpirateAlertComponent,
		// SelectRegionModalComponent,
		INDRASelectRegionModalComponent,
		// SelectThemeModalComponent,
		INDRASelectThemeModalComponent,
		// SelectAirportModalComponent,
		INDRASelectAirportModalComponent,
		WorldMapSvgComponent,
		// SelectPassengersModalComponent,
		INDRASelectPassengersModalComponent,
		// UserTotalMilesInfoComponent,
		INDRAUserTotalMilesInfoComponent,
		// IncludedPerPassengerComponent,
		INDRAIncludedPerPassengerComponent,
		// CompareBrandsComponent,
		INDRACompareBrandsComponent,
		// ConfirmModalComponent,
		INDRAConfirmModalComponent,
		// CompareFareModalComponent,
		INDRACompareFareModalComponent,
		// LoginComponent,
		INDRALoginComponent,
		INDRAAutocompleteComponent,
		AutocompleteComponent,
		// TAPPassengerDropdownComponent,
		INDRAPassengerDropdownComponent,
		PassengerDropdownComponent,
		RetrievePnrLocatorComponent,
		// TAPRetrievePnrLocatorComponent,
		INDRARetrievePnrLocatorComponent,
		// ChangeFlightModalComponent,
		INDRAChangeFlightModalComponent,
		DiscardModalComponent,
		// DatepickerModalComponent,
		INDRADatepickerModalComponent,
		// StopoverModalComponent,
		INDRAStopoverModalComponent,
		// StopoverConfirmModalComponent,
		INDRAStopoverConfirmModalComponent,
		// AncillaryBlockRentACarComponent,
		INDRAAncillaryBlockRentACarComponent,
		INDRAAncillaryBlockCartrawlerCrossSellComponent,
		// AddExtraModalComponent,
		INDRAAddExtraModalComponent,
		// ExtrasBlockComponent,
		INDRAExtrasBlockComponent,
		INDRABlockOfferByCityComponent,
		// BlockOfferByCityComponent,
		// BlockTapExperienceComponent,
		INDRABlockTapExperienceComponent,
		BlockFlightsToCityComponent,
		BlockCultureRecomendationComponent,
		// PaymentOfferBlockComponent,
		INDRAPaymentOfferBlockComponent,
		// SelectMonthModalComponent,
		INDRASelectMonthModalComponent,
		// CardOfferHighlightComponent,
		INDRACardOfferHighlightComponent,
		INDRAFlightExploreDestinationsComponent,
		// SignupErrorModalComponent,
		INDRASignupErrorModalComponent,
		// SignupErrorEmailModalComponent,
		INDRASignupErrorEmailModalComponent,
		// CardExtrasFullWidthComponent,
		INDRACardExtrasFullWidthComponent,
		// SimpleGalleryComponent,
		INDRASimpleGalleryComponent,
		RecoverTpNumberComponent,
		// BusTripModalComponent,
		INDRABusTripModalComponent,
		INDRAWeakFlightsDiscountModalComponent,
		// AlternativeFlightsButtonsComponent
		INDRAAlternativeFlightsButtonsComponent,
		BackgroundWorldAnimationComponent,
		BackgroundIconsAnimationComponent,
		DateIndraPipe,
		CountryDescPipe,
		FrequentFlyerPipe,
		ContactTypeDescPipe,
		DocumentTypeDescPipe,
		INDRAPaymentAlertComponent,
		INDRACybersourceModalComponent,
		// InsurancesComponent
		INDRAInsurancesComponent,
		MilesBalanceAnimationComponent,
		// ExtrasSidebarMilesInfoComponent,
		INDRAExtrasSidebarMilesInfoComponent,
		// TotalAmountSummaryComponent
		INDRATotalAmountSummaryComponent,
		SuccessTicketAnimationComponent,
		CorpBalanceComponent,
		UpliftInformationBlockComponent,
		UpliftBannerComponent,
		AccesrailBannerComponent,
		BookingModalComponent,
		NewContactModalComponent,
		INDRAHandBaggageInfoBannerComponent,
		INDRAStopoverBannerComponent,
		INDRAStopoverHotelsBannerComponent,
		INDRAPaymentPaybyrdModalComponent,
		INDRAPaymentAdyenModalComponent,
		NPSBannerComponent,
		INDRANPSBannerComponent,
		INDRASpecialAssistBannerComponent,
		INDRABundleCardComponent,
		INDRAPackModalComponent,
		INDRAStepsFooterComponent,
		INDRATopMenuBarComponent,
		INDRAEnrollmentBlockComponent,
		EnrollmentBlockComponent
	],
	exports: [
		// TAPContextMenuComponent,
		INDRAContextMenuComponent,
		TAPExtrasIconRowComponent,
		// TAPPassengerComponent,
		INDRAPassengerComponent,
		// TAPContactComponent,
		INDRAContactComponent,
		TAPHeroImageComponent,
		FlightDetailsModule,
		IBEAdminModule,
		// TAPFeaturesListComponent,
		INDRAFeaturesListComponent,
		// FlightEditOptionsComponent,
		INDRAFlightEditOptionsComponent,
		LoadingComponent,
		LoadingPaybyrdComponent,
		// AncillaryBlockOfferComponent,
		INDRAAncillaryBlockOfferComponent,
		AncillaryBlockGenericComponent,
		// TAPFlightRouteComponent,
		INDRAFlightRouteComponent,
		SocialShareComponent,
		BackToTopComponent,
		DatesPricesNotesComponent,
		// TimelineComponent,
		INDRATimelineComponent,
		// TicketStopoverComponent,
		INDRATicketStopoverComponent,
		SkipNavigationComponent,
		// SidebarHeaderComponent,
		INDRASidebarHeaderComponent,
		SelectFrequentFlyerProgramsComponent,
		// DaySwitcherComponent,
		INDRADaySwitcherComponent,
		// ExpirateAlertComponent,
		INDRAExpirateAlertComponent,
		PipesModule,
		// TAPMonthSelectorBarComponent,
		INDRAMonthSelectorBarComponent,
		// TotalSummaryComponent,
		INDRATotalSummaryComponent,
		// UserTotalMilesInfoComponent,
		INDRAUserTotalMilesInfoComponent,
		// IncludedPerPassengerComponent,
		INDRAIncludedPerPassengerComponent,
		// CompareBrandsComponent,
		INDRACompareBrandsComponent,
		LoadingCircleComponent,
		LoadingShadowComponent,
		AnimationsModule,
		// LoginComponent,
		INDRALoginComponent,
		// TAPPassengerDropdownComponent,
		INDRAPassengerDropdownComponent,
		INDRAAutocompleteComponent,
		// TAPRetrievePnrLocatorComponent,
		// TAPAutocompleteComponent,
		INDRARetrievePnrLocatorComponent,
		// AncillaryBlockRentACarComponent,
		INDRAAncillaryBlockRentACarComponent,
		INDRAAncillaryBlockCartrawlerCrossSellComponent,
		// BlockOfferByCityComponent,
		INDRABlockOfferByCityComponent,
		// BlockTapExperienceComponent,
		INDRABlockTapExperienceComponent,
		BlockCultureRecomendationComponent,
		BlockFlightsToCityComponent,
		// PaymentOfferBlockComponent,
		INDRAPaymentOfferBlockComponent,
		// CardOfferHighlightComponent,
		INDRACardOfferHighlightComponent,
		INDRAFlightExploreDestinationsComponent,
		// SignupErrorModalComponent,
		INDRASignupErrorModalComponent,
		// SignupErrorEmailModalComponent,
		INDRASignupErrorEmailModalComponent,
		// CardExtrasFullWidthComponent,
		INDRACardExtrasFullWidthComponent,
		// SimpleGalleryComponent,
		INDRASimpleGalleryComponent,
		BlockFlightsToCityComponent,
		RecoverTpNumberComponent,
		INDRAWeakFlightsDiscountModalComponent,
		// AlternativeFlightsButtonsComponent
		INDRAAlternativeFlightsButtonsComponent,
		BackgroundWorldAnimationComponent,
		BackgroundIconsAnimationComponent,
		DateIndraPipe,
		CountryDescPipe,
		FrequentFlyerPipe,
		ContactTypeDescPipe,
		DocumentTypeDescPipe,
		DateFormIndraModule,
		// InsurancesComponent
		INDRAInsurancesComponent,
		MilesBalanceAnimationComponent,
		// ExtrasSidebarMilesInfoComponent,
		INDRAExtrasSidebarMilesInfoComponent,
		// TotalAmountSummaryComponent
		INDRATotalAmountSummaryComponent,
		SuccessTicketAnimationComponent,
		UpliftInformationBlockComponent,
		UpliftBannerComponent,
		AccesrailBannerComponent,
		INDRAHandBaggageInfoBannerComponent,
		INDRAStopoverBannerComponent,
		INDRAStopoverHotelsBannerComponent,
		INDRAPaymentPaybyrdModalComponent,
		INDRAPaymentAdyenModalComponent,
		NPSBannerComponent,
		INDRANPSBannerComponent,
		INDRASpecialAssistBannerComponent,
		INDRABundleCardComponent,
		INDRAPackModalComponent,
		INDRAStepsFooterComponent,
		INDRATopMenuBarComponent,
		INDRAEnrollmentBlockComponent,
		EnrollmentBlockComponent
	],
	entryComponents: [
		// LoginModalComponent,
		INDRALoginModalComponent,
		// SelectRegionModalComponent,
		INDRASelectRegionModalComponent,
		// SelectThemeModalComponent,
		INDRASelectThemeModalComponent,
		// AncillaryDiscardModalComponent,
		INDRAAncillaryDiscardModalComponent,
		DiscardModalComponent,
		// ChangeFlightModalComponent,
		INDRAChangeFlightModalComponent,
		// SelectAirportModalComponent,
		INDRASelectAirportModalComponent,
		// SessionTimeoutModalComponent,
		INDRASessionTimeoutModalComponent,
		// NavigateAwayModalComponent,
		INDRANavigateAwayModalComponent,
		// SelectPassengersModalComponent,
		INDRASelectPassengersModalComponent,
		// ConfirmModalComponent,
		INDRAConfirmModalComponent,
		// CompareFareModalComponent,
		INDRACompareFareModalComponent,
		// DatepickerModalComponent,
		INDRADatepickerModalComponent,
		// StopoverModalComponent,
		INDRAStopoverModalComponent,
		// StopoverConfirmModalComponent,
		INDRAStopoverConfirmModalComponent,
		// AddExtraModalComponent,
		INDRAAddExtraModalComponent,
		// SelectMonthModalComponent,
		INDRASelectMonthModalComponent,
		INDRAFlightExploreDestinationsComponent,
		// SignupErrorModalComponent,
		INDRASignupErrorModalComponent,
		// SignupErrorEmailModalComponent,
		INDRASignupErrorEmailModalComponent,
		// ExpirateAlertComponent,
		INDRAExpirateAlertComponent,
		RecoverTpNumberComponent,
		// BusTripModalComponent,
		INDRABusTripModalComponent,
		INDRAWeakFlightsDiscountModalComponent,
		INDRAPaymentAlertComponent,
		INDRACybersourceModalComponent,
		BookingModalComponent,
		NewContactModalComponent,
		INDRAPaymentPaybyrdModalComponent,
		INDRAPaymentAdyenModalComponent,
		INDRAPackModalComponent,
    INDRANlfLoginDropdownComponent
	]
})
export class SharedModule { }
